<script>
  let {
    title,
    subtitle,
    useCases,
  } = $props();
</script>

<section class="border-b border-[#3a3a4a]">
  <div class="max-w-6xl mx-auto px-4 py-16">
    <div class="text-center mb-12">
      <p class="text-[#888890] text-xs uppercase tracking-widest mb-3">── USE CASES ──</p>
      <h2 class="text-2xl md:text-3xl font-bold text-[#e8e8ec] mb-4">
        {title}
      </h2>
      <p class="text-[#a0a0a8] max-w-2xl mx-auto text-sm leading-relaxed">
        {subtitle}
      </p>
    </div>

    <div class="grid md:grid-cols-3 gap-4">
      {#each useCases as useCase}
        <div class="p-5 border border-[#3a3a4a] bg-[#101018] hover:border-[#a855f7] transition-colors">
          <h3 class="text-base font-bold text-[#d8d8dc] mb-2">
            ▸ {useCase.title}
          </h3>
          <p class="text-[#909098] text-sm mb-4 leading-relaxed">
            {useCase.description}
          </p>
          <ul class="space-y-1.5">
            {#each useCase.benefits as benefit}
              <li class="text-[#888890] text-xs flex items-center gap-2">
                <span class="text-[#7ec699]">›</span>
                {benefit}
              </li>
            {/each}
          </ul>
        </div>
      {/each}
    </div>
  </div>
</section>
